import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import useMagnetic from '../hooks/useMagnetic';
import { scrollToSection } from '../hooks/useSmoothScroll';
import { SolarPanel } from '../components/Icons';
import './WhoWeAre.css';

gsap.registerPlugin(ScrollTrigger);

export default function WhoWeAre() {
  const sectionRef = useRef(null);
  const leftRef    = useRef(null);
  const mediaRef   = useRef(null);
  const btnRef     = useMagnetic(0.4);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(leftRef.current.children, {
        opacity: 0, y: 24, duration: 0.8, stagger: 0.12, ease: 'power3.out',
        scrollTrigger: { trigger: sectionRef.current, start: 'top 70%' },
      });
      gsap.from(mediaRef.current, {
        opacity: 0, x: 40, duration: 1, ease: 'power3.out',
        scrollTrigger: { trigger: sectionRef.current, start: 'top 70%' },
      });
    }, sectionRef);
    return () => ctx.revert();
  }, []);

  const scrollToSolutions = () => scrollToSection('#solutions');

  return (
    <section className="section section--flow who-section" id="who" ref={sectionRef}>
      <div className="container who-layout">
        <div className="who-left" ref={leftRef}>
          <p className="eyebrow">Who we are</p>
          <h2 className="who-title">
            Driving the future<br />of <span className="accent">solar</span> energy
          </h2>
          <p className="who-body">
            C-Solar designs, builds, and maintains high-performance solar systems
            engineered to last. From the first site survey to final commissioning,
            we turn Indian sunlight into reliable power — and lower bills.
          </p>
          <button className="btn" ref={btnRef} onClick={scrollToSolutions}>
            <span>Learn more</span>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M1 6h10M6 1l5 5-5 5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>

        <div className="who-media" ref={mediaRef}>
          {/* Temporary placeholder — swap for owned/licensed solar imagery */}
          <img className="who-video" src="/solar-panels.jpg" alt="Rows of solar panels under a bright sky" loading="lazy" />

          <div className="who-badge">
            <span className="who-badge-icon"><SolarPanel width="26" height="26" /></span>
            <div>
              <p className="who-badge-title">Sustainable solutions</p>
              <p className="who-badge-sub">Clean energy for a brighter tomorrow.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
